import {
  useState, useEffect, useCallback, useRef,
} from 'react';
import { fetchDeviceTotalMileageKmForAsset } from './maintenanceDeviceMileage';

/** Live total mileage from device configuration + payload (same source as Live map card). */
export function useDeviceCurrentMileage(assetId, token, agencyID, mileageSourceHint = null) {
  const [currentMileageKm, setCurrentMileageKm] = useState(null);
  const [loading, setLoading] = useState(false);
  const assetIdRef = useRef(assetId);

  useEffect(() => {
    assetIdRef.current = assetId;
  }, [assetId]);

  const refetch = useCallback(async () => {
    if (!assetId || !token || !agencyID) return;
    const requestAssetId = assetId;
    setLoading(true);
    try {
      const mileageKm = await fetchDeviceTotalMileageKmForAsset(
        token,
        agencyID,
        assetId,
        mileageSourceHint,
      );
      if (requestAssetId !== assetIdRef.current) return;
      setCurrentMileageKm(mileageKm);
    } catch {
      if (requestAssetId === assetIdRef.current) {
        setCurrentMileageKm(null);
      }
    } finally {
      if (requestAssetId === assetIdRef.current) {
        setLoading(false);
      }
    }
  }, [assetId, token, agencyID, mileageSourceHint]);

  useEffect(() => {
    setCurrentMileageKm(null);
    setLoading(Boolean(assetId));
  }, [assetId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    currentMileageKm,
    loading,
    refetch,
  };
}
